'use client';

import { useCallback } from 'react';

import { useAppDispatch } from '@/store';
import { openModal } from '@/store/slices/ui.slice';

export const useOpenAuthModal = () => {
  const dispatch = useAppDispatch();
  // Stable identity: consumers (e.g. ReferralTracker) put this in effect deps, and
  // a new function every render would re-run those effects and cancel timers.
  return useCallback(() => dispatch(openModal('signIn')), [dispatch]);
};
